<template>
    <section class="row mt-3 section-recruitments-list">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <h1 class="section-title">Tuyển dụng</h1>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="row border-bottom border-danger recruiment-header">
                        <div class="col-4 mt-3 mb-3"><h5>Vị trí</h5></div>
                        <div class="col-4 mt-3 mb-3 text-center"><h5>Bộ phận</h5></div>
                        <div class="col-4 mt-3 mb-3 text-right"><h5>Địa điểm làm việc</h5></div>
                    </div>
                    <div :data-target="'#recruitment' + recruitmentIndex" :key="recruitmentItem.recruitmentId"
                         class="row border-bottom recruiment-item" data-toggle="collapse"
                         v-for="(recruitmentItem, recruitmentIndex) in recruitmentList">
                        <div class="col-12">
                            <div class="row recruiment-description">
                                <div class="col-4 mt-3 mb-3">{{ recruitmentItem.recruitmentVacancy }}</div>
                                <div class="col-4 mt-3 mb-3 text-center">{{ recruitmentItem.recruitmentDepartment }}
                                </div>
                                <div class="col-4 mt-3 mb-3 text-right">{{ recruitmentItem.recruitmentLocation }}</div>
                            </div>
                        </div>
                        <div :id="'recruitment' + recruitmentIndex" class="col-12 collapse hide">
                            <div class="row">
                                <div class="col-12 mt-3 mb-3" v-html="recruitmentItem.recruitmentDetail"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "RecruitmentPageComponent",
        data() {
            return {
                inFetching: false,
                recruitmentList: []
            }
        },
        async mounted() {
            if (this.$store.state.recruitment.recruitmentList.length === 0) {
                // set inFecthing mode
                this.inFetching = true;

                await this.$store.dispatch('getAllRecruitmentList')
                    .then(() => {
                        this.recruitmentList = this.$store.state.recruitment.recruitmentList;
                    })
                    .finally(() => {
                        this.inFetching = true;
                    });
            } else {
                this.recruitmentList = this.$store.state.recruitment.recruitmentList;
            }
        }
    }
</script>

<style scoped>

</style>
